import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data from "../../Data/additional/additionalData.json";
import Questions from "./Questions/Questions.js";

export default function Additional() {
  return (
    <section className="contacts additional">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Дополнительное профессиональное образование
      </h1>

      <Accordion data={data} />

      <h3 className="about-nii__title antiCorruption__title">
        Последипломное обучение в ГБУ СО "УрНИИДВиИ" проводится с целью
        предоставления специалистам дополнительного образования в сфере
        дерматовенерология (на основании государственной федеральной лицензии
        №2029, выдана Федеральной службой по надзору в сфере образования и науки
        28 марта 2016г.)
      </h3>
      <h3 className="about-nii__title antiCorruption__title additional__title">
        Обучение осуществляется по следующим программам:
      </h3>

      <div className="directions__blocks additional__blocks">
        <div className="directions__block">
          <div className="directions__more">
            <h4 className="directions__more-title">
              Циклы повышения квалификации
            </h4>
            <p className="directions__more-text">144 учебных часа</p>
            <h4 className="directions__more-title">
              <a
                href="/education/additional/advanced-training"
                className="directions__more-link"
              >
                Подробнее →
              </a>
            </h4>
          </div>
        </div>
        <div className="directions__block">
          <div className="directions__more">
            <h4 className="directions__more-title">Сертификационный цикл</h4>
            <p className="directions__more-text">144 учебных часа</p>
            <h4 className="directions__more-title">
              <a
                href="/education/additional/certification-cycle"
                className="directions__more-link"
              >
                Подробнее →
              </a>
            </h4>
          </div>
        </div>
        <div className="directions__block">
          <div className="directions__more">
            <h4 className="directions__more-title">
              Краткосрочное тематическое усовершенствование
            </h4>
            <p className="directions__more-text">72 учебных часа</p>
            <h4 className="directions__more-title">
              <a
                href="/education/additional/short-improvement"
                className="directions__more-link"
              >
                Подробнее →
              </a>
            </h4>
          </div>
        </div>
        <div className="directions__block">
          <div className="directions__more">
            <h4 className="directions__more-title">
              Профессиональная переподготовка по специальности "Косметология"
            </h4>
            <p className="directions__more-text"></p>
            <h4 className="directions__more-title">
              <a
                href="/education/additional/professional-retraining"
                className="directions__more-link"
              >
                Подробнее →
              </a>
            </h4>
          </div>
        </div>
      </div>

      <Questions />
    </section>
  );
}
